<template>
	<div class="page404">
		<div class="container">
			<span class="title404">404</span>
			<span class="subtitle404">Página no encontrada</span>
			<span>La página a la que intentas acceder no existe o no está disponible</span>
			<router-link :to="{name: 'home'}">Volver al inicio</router-link>
		</div>
	</div>
</template>

<script>
	export default{
		name: 'pagenotfound',
		data(){
			return {

			}
		}
	}
</script>

<style lang="scss" scoped>
	.page404{
		min-height: calc(100vh - var(--height-top-header) - var(--height-footer));
		width: 100%;
		margin: 0;
		padding: 0;
		position: relative;
		@include flex(column, center, center);

		.container{
			@include flex(column, center, center);
			height: 100%;
			max-width: 1260px;
			padding: 0px 24px;

			.title404{
				color: var(--color-blue-dark);
				font-size: 210px;
				line-height: 1em;
				text-align: center;
				font-family: var(--font-family-kapra-bold);
			}

			.subtitle404{
				font-family: var(--font-family-poppins);
				font-weight: var(--font-weight-bold);
				color: var(--color-red);
				font-size: 32px;
				line-height: 1em;
				text-align: center;
				text-transform: uppercase;
			}

			span{
				font-family: var(--font-family-fira);
				font-weight: var(--font-weight-bold);
				color: var(--color-dark);
				line-height: 1em;
				margin-bottom: 15px;
				text-align: center;
			}

			a{
				color: var(--color-dark);
				font-family: var(--font-family-fira);
				text-decoration: underline;
			}
		}
	}
</style>